import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  rolesData: [],
  addModal: false,
  editModal: false,
  totalPageNo: 1,
  selectedUser: null,
  addUserLoading: false,
  userDeleteModalOpen: false,
  deleteUserLoading: false,
  editRole: null,
  currentPageNo: 1,
  userImageFile: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCurrentPageNo: (state, action) => {
      state.currentPageNo = action.payload;
    },
    setUserImageFile: (state, action) => {
      state.userImageFile = action.payload;
    },
    setRolesData: (state, action) => {
      state.rolesData = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTotalPageNo: (state, action) => {
      state.totalPageNo = action.payload;
    },
    toggleAddModal: (state) => {
      state.addModal = !state.addModal;
    },
    toggleEditModal: (state) => {
      state.editModal = !state.editModal;
    },
    setEditRole: (state, action) => {
      state.editRole = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },
    setUserDeleteModalOpen: (state, action) => {
      state.userDeleteModalOpen = action.payload;
    },
    setAddUserLoading: (state, action) => {
      state.addUserLoading = action.payload;
    },
    setDeleteUserLoading: (state, action) => {
      state.deleteUserLoading = action.payload;
    },
  },
});

export const {
  setLoading,
  setTotalPageNo,
  toggleAddModal,
  toggleEditModal,
  setUserDeleteModalOpen,
  setDeleteUserLoading,
  setCurrentPageNo,
  setEditRole,
  setRolesData,
  setSelectedUser,
  clearSelectedUser,
  setUserImageFile,
  setAddUserLoading,
} = userSlice.actions;

export default userSlice.reducer;
